import React, { useState, useEffect } from 'react';
import StudyText from './StudyText';
import LaravelApi from '../../components/laravelApi/LaravelApi';
import study from '../../../assets/images/aboutMe/study.png';
import { studyList } from '../../../fakeDatabase';

const StudiesList = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    //const response = await LaravelApi.get('/studies', {});
    setData(studyList);
  }

  console.log(data);
  if (data != null) {
    var studiesList = data.map(data => {
      return <StudyText 
        key={data.center}
        center={data.center}  
        study={data.study}
        from={data.from}
        to={data.to}
      />
    });

    return (
      <div>
        <img className="ui small centered image" src={study} alt="studies" /> 
        {studiesList}
      </div>
    )
  }
  
  return '';
}

export default StudiesList;